var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.756 13.838H3.089v-3.333H1.756v4a.667.667 0 00.667.667h12a.667.667 0 00.666-.667v-4h-1.333v3.333z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74 9.71L5.105 7.077l-.943.943 4.243 4.242 4.243-4.242-.943-.943L9.073 9.71V2.262H7.739V9.71z",
    fill: "#fff"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxNyAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEzLjc1NTkgMTMuODM4M0gzLjA4OTE5TDMuMDg5MTkgMTAuNTA1SDEuNzU1ODZMMS43NTU4NiAxNC41MDVDMS43NTU4NiAxNC42ODE4IDEuODI2MSAxNC44NTEzIDEuOTUxMTIgMTQuOTc2NEMyLjA3NjE1IDE1LjEwMTQgMi4yNDU3MiAxNS4xNzE2IDIuNDIyNTMgMTUuMTcxNkwxNC40MjI1IDE1LjE3MTZDMTQuNTk5MyAxNS4xNzE2IDE0Ljc2ODkgMTUuMTAxNCAxNC44OTM5IDE0Ljk3NjRDMTUuMDE5IDE0Ljg1MTMgMTUuMDg5MiAxNC42ODE4IDE1LjA4OTIgMTQuNTA1TDE1LjA4OTIgMTAuNTA1SDEzLjc1NTlWMTMuODM4M1oiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik03LjczOTI4IDkuNzEwMjFMNS4xMDU5NSA3LjA3Njg4TDQuMTYzMjggOC4wMTk1NEw4LjQwNTk1IDEyLjI2MjJMMTIuNjQ4NiA4LjAxOTU0TDExLjcwNiA3LjA3Njg4TDkuMDcyNjIgOS43MTAyMVYyLjI2MjIxTDcuNzM5MjggMi4yNjIyMVY5LjcxMDIxWiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==";
export { SvgDownload as ReactComponent };